import SetIsActive from '@/common/components/SetIsActive'
import useMutationUpdatePartner from '@/modules/manage-player/api/hooks/useMutationUpdatePartner'
import { useQueryClient } from '@tanstack/react-query'
import { PartnerQueryKeys, PlayerQueryKeys } from '@/modules/manage-player/keys'

interface PartnerActiveToggleProps {
	partnerId: string
	partnerNickname: string
	isActive: boolean
}

export default function PartnerActiveToggle({
	partnerId,
	partnerNickname,
	isActive,
}: PartnerActiveToggleProps) {
	const queryClient = useQueryClient()
	const { mutateAsync: updatePartner } = useMutationUpdatePartner()

	const handleMutate = async (value: boolean) => {
		await updatePartner({
			id: partnerId,
			payload: { isActive: value },
		})
		queryClient.invalidateQueries({
			queryKey: [PartnerQueryKeys.GetPartners],
		})
		queryClient.invalidateQueries({
			queryKey: [PartnerQueryKeys.GetPartnerById],
		})
		queryClient.invalidateQueries({
			queryKey: [PlayerQueryKeys.GetPlayerList],
		})
	}

	return (
		<div className="flex items-center gap-2">
			<SetIsActive
				defaultChecked={isActive}
				onMutate={handleMutate}
				successMessage={
					isActive ? 'ปิดใช้งานพาร์ทเนอร์สำเร็จ' : 'เปิดใช้งานพาร์ทเนอร์สำเร็จ'
				}
			/>
			<span className="text-xs text-muted-foreground">({partnerNickname})</span>
		</div>
	)
}
